<template>
  <ValidationProvider :name="name" :rules="rules" v-slot="{ errors }" translate="no">
    <label v-if="label">{{label}}</label>
    <div class="danger">
      <slot v-bind:validation="{ errors: errors, any: errors.length > 0 }"/>
      <component v-if="errors.length > 0 && !horizontal" :is="horizontal ? 'p' : 'span'" class="error-text text-danger">
        {{ errors[0] }}
        <span v-if="errorDescription !== undefined">{{errorDescription}}</span>
      </component>
    </div>
  </ValidationProvider>

</template>

<script>
  export default {
    name: "FormItem",
    props: ['name', 'rules', 'label', 'errorDescription', 'horizontal'],
    data() {
      return {

      }
    }
  }
</script>

<style scoped>
  label {
    margin-bottom: 0;
    font-size: 11px;
  }

  .error-text {
    font-size: 9px;
    /*margin-bottom: 0.25rem;*/
  }

  input {
    color: red !important;
  }
</style>
